<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
    <wQ-check-base-standard-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></wQ-check-base-standard-form>
  </j-modal>
</template>

<script>

  import WQCheckBaseStandardForm from './WQCheckBaseStandardForm'
  export default {
    name: 'WQCheckBaseStandardModal',
    components: {
      WQCheckBaseStandardForm
    },
    data () {
      return {
        title:'',
        width:1100,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
        
      }
    }
  }
</script>